import { JsonObject, JsonProperty } from 'json2typescript';

//** Model sloupků stanice * /
@JsonObject("StopPoint")
export class StopPoint {
  @JsonProperty('code', Number)
  Code: number = 0;
  @JsonProperty('platform', String)
  platform: string = "";
  @JsonProperty('lat', Number)
  lat: number | undefined = undefined;
  @JsonProperty('lon', Number)
  lon: number|undefined = undefined;
}
